import { render } from "./Addclassify.vue?vue&type=template&id=18bbbac9&scoped=true"
import script from "./Addclassify.vue?vue&type=script&lang=js"
export * from "./Addclassify.vue?vue&type=script&lang=js"

import "./Addclassify.vue?vue&type=style&index=0&id=18bbbac9&lang=scss&scoped=true"
import "./Addclassify.vue?vue&type=style&index=1&id=18bbbac9&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bbbac9"]])

export default __exports__